import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { Actions as ADMINACTIONS } from '../../../store/actions/adminActions';
import { Actions as USAGE_ACTIONS } from '../../../store/actions/usageActions';

import { Pencil, Trash2, Loader2, AlertTriangle } from 'lucide-react';
import _, { isArray } from 'lodash';
import moment from 'moment';
import Select from 'src/components/ui/BrandSelect';
import { AutoSizer, Column, Table } from 'react-virtualized';
import { Button } from '../../ui/button';
import { adminPortalSelect } from '../../utils/ReactSelectStyles';
import { Spinner } from '../../ui/spinner';
import { Tooltip, TooltipTrigger, TooltipContent, TooltipProvider } from '../../ui/tooltip';
import { Checkbox } from '../../ui/checkbox';
import { Switch } from '../../ui/switch';

const UsageDataListTable = ({
  branding,
  tableName,
  page,
  filterSize,
  tableSize,
  setTotalItems,
  setShowHide,
  setFilter,
  filter,
  usageData,
  parentUsage,
  options,
  setShowPagination,
  toggleModal,
  showLoader,
  handleTableSizeChange,
  getItemsByTermsFromIndexExport,
  canEditAdminPortal,
  showUsageDataModal,
}) => {
  const get_OS_terms = () => ({ filters: filter, page, tableSize: tableSize.value });
  const { headers } = branding?.fonts[0]?.font || {};

  const [localUsageData, setLocalUsageData] = useState(parentUsage);
  const [selectAllChecked, setSelectAllChecked] = useState(false);
  const [exporting, setExporting] = useState(false);
  const checkedList = isArray(localUsageData) && localUsageData?.filter((item) => item.checked);

  const selectAll = () => {
    setSelectAllChecked(!selectAllChecked);
    setLocalUsageData((prev) => prev.map((item) => ({ ...item, checked: !selectAllChecked })));
  };

  const handleFilterUsage = (e) => {
    const checked = e.target.checked;
    if (checked) {
      return setLocalUsageData(usageData);
    }
    setLocalUsageData(parentUsage);
  };

  useEffect(() => {
    if (checkedList.length === 0) setSelectAllChecked(false);
  }, [checkedList.length]);

  useEffect(() => {
    if (usageData.length > 0) {
      setLocalUsageData(parentUsage);
    }
  }, [usageData, parentUsage]);

  useEffect(() => {
    setLocalUsageData(parentUsage);
  }, [usageData, parentUsage]);

  if (usageData && !isArray(usageData)) {
    return <div>{usageData}</div>;
  }

  if (showLoader) {
    return <Spinner />;
  }

  const formatCellValue = ({ cellData, dataKey }) => {
    if (dataKey) {
      return (
        <div>
          <Tooltip>
            <TooltipTrigger asChild>
              <div style={{ cursor: 'pointer' }} className='admin_portal_cellData_description'>
                {cellData}
              </div>
            </TooltipTrigger>
            <TooltipContent>{cellData}</TooltipContent>
          </Tooltip>
        </div>
      );
    }
  };

  const _headerRenderer = () => {
    return <div>{usageData.length > 1 && <Checkbox onCheckedChange={selectAll} checked={selectAllChecked} />}</div>;
  };

  const bulkRenderer = ({ cellData, rowData }) => {
    return (
      <Checkbox
        checked={rowData?.checked}
        onCheckedChange={() => {
          const newUsageData = [...localUsageData];
          const findIndex = localUsageData.findIndex((item) => item.id === rowData.id);
          newUsageData[findIndex].checked = !newUsageData[findIndex].checked;
          setLocalUsageData(newUsageData);
        }}
        aria-label='controlled'
      />
    );
  };

  const exportData = async () => {
    setExporting(true);
    const newFilter = { ...filter };
    const filterName = 'generateExport';
    newFilter[filterName] = true;
    await getItemsByTermsFromIndexExport(tableName, newFilter, page, tableSize?.value);
    setExporting(false);
  };

  const formatUsageTypesValues = ({ cellData, rowData, dataKey }) => {
    if (
      [
        'subentity',
        'vehicle',
        'production',
        'metric',
        'waste',
        'seat',
        'load',
        'fuel',
        'entity',
        'finallocation',
        'originlocation',
        'price',
        'factorprovider',
        'facility',
        'organisation',
      ].includes(dataKey) &&
      cellData !== null &&
      cellData !== undefined &&
      cellData !== 'null'
    ) {
      return (
        <div>
          <Tooltip>
            <TooltipTrigger asChild>
              <div
                style={{ cursor: 'pointer', whiteSpace: 'pre-wrap', overflow: 'hidden', height: 'inherit' }}
                className='admin_portal_cellData_description'>
                {cellData ? _.find(options?.[dataKey], { value: cellData })?.label : ''}
              </div>
            </TooltipTrigger>
            <TooltipContent>
              {cellData && _.find(options?.[dataKey], { value: cellData })?.label}
            </TooltipContent>
          </Tooltip>
        </div>
      );
    } else {
      if (cellData === null || cellData === 'null' || cellData === undefined) {
        return (
          <div>
            <Tooltip>
              <TooltipTrigger asChild>
                <div style={{ textAlign: 'center', overflowX: 'auto', maxHeight: '100px', opacity: '40%' }}>{'<null>'}</div>
              </TooltipTrigger>
              <TooltipContent>{'<null>'}</TooltipContent>
            </Tooltip>
          </div>
        );
      }
    }

    if (['creationDate', 'modifiedDate', 'dateStart', 'dateEnd'].includes(dataKey))
      return (
        <div>
          <Tooltip>
            <TooltipTrigger asChild>
              <div
                style={{ cursor: 'pointer', whiteSpace: 'pre-wrap', overflow: 'hidden', height: 'inherit' }}
                className='admin_portal_cellData_description'>
                {cellData && moment(cellData).format('DD/MM/YYYY')}
              </div>
            </TooltipTrigger>
            <TooltipContent>{cellData && moment(cellData).format('DD/MM/YYYY')}</TooltipContent>
          </Tooltip>
        </div>
      );

    if (dataKey)
      return (
        <div>
          <Tooltip>
            <TooltipTrigger asChild>
              <div style={{ cursor: 'pointer' }} className='admin_portal_cellData_description'>
                {cellData}
              </div>
            </TooltipTrigger>
            <TooltipContent>{cellData}</TooltipContent>
          </Tooltip>
        </div>
      );
  };

  const userActions = ({ rowData }) => {
    return (
      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
        <Tooltip>
          <TooltipTrigger asChild>
            <Pencil
              size={16}
              strokeWidth={1.5}
              className='cursor-pointer'
              onClick={() => {
                showUsageDataModal(true, rowData, true);
              }}
            />
          </TooltipTrigger>
          <TooltipContent>Edit Usage Data</TooltipContent>
        </Tooltip>
        <Tooltip>
          <TooltipTrigger asChild>
            <Trash2
              size={16}
              strokeWidth={1.5}
              className='cursor-pointer ml-1'
              onClick={() => toggleModal(true, 'usageData-delete', rowData)}
            />
          </TooltipTrigger>
          <TooltipContent>Delete Usage Data</TooltipContent>
        </Tooltip>
      </div>
    );
  };

  if (usageData && !usageData.length > 0) {
    return (
      <div style={{ display: 'flex', alignItems: 'center' }}>
        <div className='alert-message'>
          <AlertTriangle size={16} />
          <span>No Usage Data Found</span>
        </div>
        <Button
          id='reset-btn'
          onClick={() => {
            toggleModal(true, 'usageData-bulk_search', {
              tableName,
              filter,
              page,
              tableSize: tableSize?.value,
              type: 'usageData-bulk_search',
            });
          }}
          style={{ fontSize: 16, marginLeft: '3vh' }}>
          Filter
        </Button>
        <Button
          id='reset-btn'
          onClick={() => {
            setFilter({});
            setTotalItems(0);
            setShowPagination(false);
            setShowHide(false);
          }}
          style={{ width: '10vh', height: 'fit-content', fontSize: 16, marginLeft: '2vh' }}>
          Reset
        </Button>
      </div>
    );
  }

  return (
    <TooltipProvider>
      <section className='panel' style={{ fontFamily: headers }}>
        <header
          className='panel-heading'
          style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', width: '100%' }}>
          Usage Data Results
          <div style={{ marginRight: 10, display: 'flex', alignItems: 'baseline' }}>
            <Select
              options={filterSize}
              name={'tableSize'}
              defaultValue={filterSize[0]}
              onChange={handleTableSizeChange}
              styles={{
                ...adminPortalSelect,
                container: (x) => ({ ...x, margin: '0px 40px' }),
                control: (x) => ({ ...x, ...adminPortalSelect.control, width: 100 }),
              }}
              placeholder={'Table Size'}
              value={tableSize}
            />
            <div className='flex items-center gap-2'>
              <Switch onCheckedChange={(checked) => handleFilterUsage({ target: { checked } })} />
              <span className='text-sm'>Children Usage</span>
            </div>
            <Button
              id='reset-btn'
              onClick={() => {
                toggleModal(true, 'usageData-bulk_search', {
                  tableName,
                  filter,
                  page,
                  tableSize: tableSize?.value,
                  type: 'usageData-bulk_search',
                });
              }}
              style={{ fontSize: 16, marginLeft: '3vh' }}>
              Filter
            </Button>
            <Button
              id='reset-btn'
              onClick={() => {
                setFilter({});
                setTotalItems(0);
                setShowPagination(false);
                setShowHide(false);
              }}
              style={{ fontSize: 16, marginLeft: '3vh' }}>
              Reset
            </Button>
            <Button
              id='export-btn'
              onClick={() => {
                exportData();
              }}
              disabled={_.isEmpty(filter) || exporting}
              style={{ fontSize: 16, marginLeft: '3vh' }}>
              {exporting && <Loader2 size={16} className='animate-spin inline mr-1' />} Export
            </Button>
            {checkedList?.length > 1 && (
              <>
                <div style={{ marginRight: '1.5vh' }}>
                  <Button
                    variant='outline'
                    size='sm'
                    style={{ width: '12vh', fontSize: 16, marginLeft: '3vh', textTransform: 'none' }}
                    onClick={() => {
                      toggleModal(true, 'usageData-bulk_edit', checkedList, null, get_OS_terms());
                    }}>
                    Bulk Edit
                  </Button>
                </div>
                <div>
                  <Button
                    variant='outline'
                    size='sm'
                    style={{ fontSize: 16, textTransform: 'none' }}
                    onClick={() => {
                      toggleModal(true, 'usageData-bulk_delete', checkedList, null, get_OS_terms());
                    }}>
                    Bulk Delete
                  </Button>
                </div>
              </>
            )}
          </div>
        </header>
        <div className='panel-body' style={{ height: '100vh', overflowX: 'auto' }}>
          <div style={{ width: '100%', height: '100%', display: !localUsageData?.length > 0 ? 'none' : 'block' }}>
            <AutoSizer>
              {({ width, height }) => (
                <Table
                  width={width + 1000}
                  height={height}
                  rowHeight={100}
                  headerHeight={50}
                  headerStyle={{ verticalAlign: 'bottom', width: '100%', display: 'flex', justifyContent: 'center' }}
                  rowStyle={({ index }) => {
                    const rowData = localUsageData[index];
                    const shouldHighlight = rowData && rowData.checked;
                    return {
                      backgroundColor: shouldHighlight ? 'lightblue' : 'white',
                      textAlign: 'center',
                      textOverflow: 'auto-flow',
                      fontSize: 13,
                    };
                  }}
                  headerClassName='admin_portal_column_headers'
                  rowCount={(localUsageData && localUsageData.length) || null}
                  rowGetter={({ index }) => localUsageData[index]}>
                  {canEditAdminPortal && (
                    <Column dataKey='id' width={60} headerRenderer={_headerRenderer} cellRenderer={bulkRenderer} />
                  )}
                  {canEditAdminPortal && <Column label='Actions' dataKey='id' width={75} cellRenderer={userActions} />}
                  <Column label='ID' dataKey='id' width={75} cellRenderer={formatCellValue} />
                  <Column label='Entity' dataKey='entity' width={150} cellRenderer={formatUsageTypesValues} />
                  <Column label='Subentity' dataKey='subentity' width={150} cellRenderer={formatUsageTypesValues} />
                  <Column label='Facility' dataKey='facility' width={150} cellRenderer={formatUsageTypesValues} />
                  <Column label='Metric' dataKey='metric' width={85} cellRenderer={formatUsageTypesValues} />
                  <Column label='Fuel' dataKey='fuel' width={85} cellRenderer={formatUsageTypesValues} />
                  <Column label='Load' dataKey='load' width={85} cellRenderer={formatUsageTypesValues} />
                  <Column label='Production' dataKey='production' width={85} cellRenderer={formatUsageTypesValues} />
                  <Column label='Seat' dataKey='seat' width={85} cellRenderer={formatUsageTypesValues} />
                  <Column label='Vehicle' dataKey='vehicle' width={85} cellRenderer={formatUsageTypesValues} />
                  <Column label='Waste' dataKey='waste' width={85} cellRenderer={formatUsageTypesValues} />
                  <Column label='Final Location' dataKey='finallocation' width={85} cellRenderer={formatUsageTypesValues} />
                  <Column label='Origin Location' dataKey='originlocation' width={85} cellRenderer={formatUsageTypesValues} />
                  <Column label='Price' dataKey='price' width={85} cellRenderer={formatUsageTypesValues} />
                  <Column label='Factor Provider' dataKey='factorprovider' width={85} cellRenderer={formatUsageTypesValues} />
                  <Column label='Organisation' dataKey='organisation' width={150} cellRenderer={formatUsageTypesValues} />
                  <Column label='Usage' dataKey='usage' width={150} cellRenderer={formatCellValue} />
                  <Column label='Start Date' dataKey='dateStart' width={150} cellRenderer={formatUsageTypesValues} />
                  <Column label='End Date' dataKey='dateEnd' width={150} cellRenderer={formatUsageTypesValues} />
                  <Column label='Modified Date' dataKey='modifiedDate' width={150} cellRenderer={formatUsageTypesValues} />
                  <Column label='Source' dataKey='source' width={150} cellRenderer={formatUsageTypesValues} />
                </Table>
              )}
            </AutoSizer>
          </div>
        </div>
      </section>
    </TooltipProvider>
  );
};

const mapStateToProps = (state, ownProps) => {
  const { page, setTableSize, tableSize, handleTableSizeChange } = ownProps;
  const tableName = 'usageData';
  const usageData = state?.admin?.termsItems?.items || [];
  const profile = state.profile?.details;
  const parentUsage = usageData.length > 0 && usageData?.filter((item) => !item.parentID);

  return {
    totalItems: state?.admin?.termsItems?.totalCount,
    branding: state.branding,
    adminPortalModal: state.admin?.modal?.adminPortalModal,
    tableName,
    filterSize: state.admin?.filterSize,
    page,
    tableSize,
    handleTableSizeChange,
    setTableSize,
    usageData: usageData,
    parentUsage: parentUsage,
    showLoader: state?.showLoader,
    canEditAdminPortal: profile?.permissions?.portal?.includes('EDIT_ADMIN'),
  };
};

const mapDispatchToProps = (dispatch) => ({
  toggleModal: (status, action, item, notAutoClose) =>
    dispatch(ADMINACTIONS.toggleModal(status, action, item, notAutoClose)),
  filterFromOpeanSearch: (index, query) => dispatch(ADMINACTIONS.filterFromOpeanSearch(index, query)),
  showUsageDataModal: (status, item, adminPortal) => dispatch(USAGE_ACTIONS.showUsageDataModal(status, item, adminPortal)),
  getItemsByTermsFromIndexExport: (index, filters, page, size) =>
    dispatch(ADMINACTIONS.getItemsByTermsFromIndexExport(index, filters, page, size)),
});

export default connect(mapStateToProps, mapDispatchToProps)(UsageDataListTable);
